/**
 *  @module "validation.util"
 */

define('formkit/validation.util',['require','exports','module','underscore','backbone','bluebird','uuid'],function(require, exports, module) {
  //prettier-ignore
  var _           = require('underscore'),
      Backbone    = require('backbone'),
      Promise     = require('bluebird'),
      UUID        = require('uuid');

  /**
   * @class ValidationUtil
   */

  var ValidationUtil = {
    /**
     * @method getFailedValidationsArray
     *
     * @param  {Object} templateObjectModel
     * @returns {Array} an array of failed validations
     */

    getFailedValidationsArray: function(templateObjectModel) {
      var failedValidationsArray = [];
      var self = this;

      this.eachDescendent(
        templateObjectModel,
        function(childTemplateObjectModel) {
          var answerModel = this.getAnswerModel(childTemplateObjectModel);
          var answerModelFailedValidations = _.map(
            answerModel.get('failedValidations'),
            function(model) {
              /**
               * @todo getAnswerValueModel is defined in form.object.util, must make dependency explicit or remove it
               */
              var answerValueModel;
              if (model.index != null) {
                // only get the answer value if there is an index
                // because getting the answer value model creates that model by default
                // if it does not exist
                answerValueModel = this.getAnswerValueModel(childTemplateObjectModel, model.index);
              }
              model.templateObjectId = childTemplateObjectModel.get('id');
              model.answerModelId = answerModel.id;
              model.answerId = answerModel.id;
              model.answerValueModelId = answerValueModel ? answerValueModel.id : null;
              model.answerValueId = answerValueModel ? answerValueModel.id : null;
              return model;
            },
            this
          );

          if (answerModelFailedValidations && answerModelFailedValidations.length) {
            for (var i = 0; i < answerModelFailedValidations.length; i++) {
              failedValidationsArray.push(answerModelFailedValidations[i]);
            }
          }
          // TODO: getAnswerValueCollection is defined in form.object.util, must make dependency explicit or remove it
          var answerValueCollection = this.getAnswerValueCollection(childTemplateObjectModel);
          var answerValueModelFailedValidations = answerValueCollection.reduce(function(memo, answerValueModel) {
            return memo.concat(
              self.getFailedValidationsArrayFromAnswerValueModel(answerValueModel, childTemplateObjectModel)
            );
          }, []);

          if (answerValueModelFailedValidations && answerValueModelFailedValidations.length) {
            for (var i = 0; i < answerValueModelFailedValidations.length; i++) {
              failedValidationsArray.push(answerValueModelFailedValidations[i]);
            }
          }
        },
        this,
        { includeSelf: true }
      );

      return failedValidationsArray;
    },

    /**
     * @method getFailedValidationsArrayFromAnswerValueModel
     *
     * @param  {Object} answerValueModel
     * @param  {Object} templateObjectModel
     * @returns {Array} failed validations array from AnswerValueModel
     */

    getFailedValidationsArrayFromAnswerValueModel: function(answerValueModel, templateObjectModel) {
      if (!(answerValueModel instanceof Backbone.Model)) {
        return [];
      }
      var answerModel = this.getAnswerModel(templateObjectModel);

      return _.map(answerValueModel.get('failedValidations'), function(model) {
        model.templatedObjectId = answerModel.get('templateObjectId');
        model.answerModelId = answerModel.id;
        model.answerId = answerModel.id;
        model.answerValueModelId = answerValueModel.id;
        model.answerValueId = answerValueModel.id;
        return model;
      });
    },

    /**
     * @method getValidationMessage
     *
     * @param  {String} failedValidation
     * @param  {Object} templateObjectModel
     * @returns {String} Validation Message
     */

    getValidationMessage: function(failedValidation, templateObjectModel) {
      var condition = _.result(failedValidation, 'condition') || {};

      switch (_.result(condition, 'operation')) {
        case 'filled':
          return 'This question requires an answer.';

        case 'rto_filled':
          return 'All research team members must have a Name, a Role, and at least one Internal Association assigned.'

        case 'rto_PI_not_unique':
          return 'Only one research team member may be designated as the Principal Investigator.'

        case 'rto_PI_empty':
          return 'At least one member of the research team must be designated as the Principal Investigator.'
          
        // Research Team Object credit total validation is not considered a "visible" validation because the object
        // contains the error messaging for credit totals, and thus we need to flag it as something whose normal message
        // rendering should be suppressed
        case 'rto_credit_totals':
          if (!condition.parameters.length) {
            condition.parameters.push({ suppressErrorMessage: true });
          }
          return ' ';
      }
      return ' ';
    },
  };

  module.exports = ValidationUtil;
});

